import React from 'react';
import CheckBox from '../../../../../componentes/checkbox/checkbox.component';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Button,
  Row,
  Col
} from 'reactstrap';
import './modal.imprimir.styles.css';
import IntlMessage from '../../../../../helpers/intlMessage';

export const ModalImprimirPage = props => (
  <div className='mv-container-imprimir'>
    <Modal size='sm' isOpen={props.openModalImprimir} toggle={props.closeModal}>
      <ModalHeader toggle={props.closeModal}>
        <IntlMessage id = "dashboards.examDetail.generateImpression"/>
      </ModalHeader>
      <ModalBody>
        <div>
          <FormGroup>
            <Col>
              {props.etapas.map((et, index) => {
                return (
                  <Row
                    key={index}
                    className={`checkbox${et.disabled ? '_disabled' : ''}`}
                  >
                    <CheckBox
                      label={et.etapa === 'NOTAS' ? props.labelNotas : et.etapa}
                      onChange={e =>
                        props.checkedEtapa(et.etapa, e.currentTarget.checked)
                      }
                      checked={et.checked}
                      disabled={et.disabled}
                    ></CheckBox>
                  </Row>
                );
              })}
            </Col>
          </FormGroup>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={props.closeModal}>
          <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <Button
          color='primary'
          onClick={e => props.imprimirLaudos()}
          disabled={!props.etapas.find(et => et.checked)}
        >
          <IntlMessage id = "dashboards.examDetail.generate"/>
        </Button>
      </ModalFooter>
    </Modal>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/imprimir_laudo/modal.imprimir.page.js